import {IResponse, IRouteDefinitionParams, IRuleset, ITableColumn} from '../../index';
import {ObjectTypeId} from "../../constants";
import {template as tpl, viewModel as SearchRuleset} from "./search";
import {IDialogOptions} from "../dialog/index";
import {ISplitButtonParams} from "@component/button/splitButton/split-button";

export let template = tpl;

interface IParams {
    /** Ruleset ids omitted from search results (client-side, per page). */
    excludeObjectIds?: number[]
    selectedObject: KnockoutObservable<IRuleset>
    dialog?: IDialogOptions
}

export class viewModel extends SearchRuleset {
    private selectedObject: KnockoutObservable<IRuleset>;
    private readonly excludeObjectIds: number[];
    /** Caps auto-page skips when every row on a page is already selected. */
    private emptyExcludePageSkips = 0;

    public override TABLE: Array<ITableColumn> = [
        {
            key: "Id",
            label: "Id"
        },
        {
            key: "Name",
            label: "Navn"
        },
        {
            key: "ObjectTypeId",
            label: "Objekttype"
        },
    ];
    private dialog?: IDialogOptions;

    constructor(params: IParams & IRouteDefinitionParams) {
        super(params);
        if (params.dialog) {
            this.dialog = params.dialog;
        }
        this.selectedObject = params.selectedObject;
        this.excludeObjectIds = params.excludeObjectIds ?? [];
    }

    protected override populatePageButtons() {
    }

    /** Pick dialog is for choosing a ruleset — no create action. */
    protected override getSearchSplitButtonParams(): ISplitButtonParams | null {
        return null
    }

    protected override getSearchHeaderSplitButtonParams(): ISplitButtonParams | null {
        return null
    }

    protected override onSearchSuccess(response: IResponse) {
        if (this.excludeObjectIds.length && Array.isArray(response.data)) {
            const original = response.data as IRuleset[];
            const exclude = new Set(this.excludeObjectIds);
            const data = original.filter(o => !exclude.has(o.id));
            const removed = original.length - data.length;
            const totalresults = Math.max(0, (response.totalresults ?? 0) - removed);

            // Filtering can empty the page while API totalresults stays > 0, which leaves the
            // picker stuck on "loading" (no-hits only when totalresults === 0). Skip ahead/back.
            if (!data.length && removed && this.emptyExcludePageSkips < 50) {
                const pageSize = this.resultsprpage() || original.length || 1;
                const originalTotal = response.totalresults ?? 0;
                const pagenr = response.pagenr ?? 0;
                if ((pagenr + 1) * pageSize < originalTotal) {
                    this.emptyExcludePageSkips++;
                    this.pagenr(pagenr + 1);
                    return;
                }
                if (pagenr > 0) {
                    this.emptyExcludePageSkips++;
                    this.pagenr(pagenr - 1);
                    return;
                }
            }

            this.emptyExcludePageSkips = 0;
            response = {
                ...response,
                data,
                // Empty after exclude with nowhere to page → real no-hits for the message state.
                totalresults: data.length ? totalresults : 0,
            };
        }
        super.onSearchSuccess(response);
    }

    override onRowClick(data: IRuleset) {
        if (this.excludeObjectIds.includes(data.id)) {
            return;
        }
        this.selectedObject(data);
        if (this.dialog?.doClose) {
            this.dialog.doClose();
        }
    }

    override canRowClick(item: IRuleset): boolean {
        return item.objecttype.id == ObjectTypeId.User
            && !this.excludeObjectIds.includes(item.id);
    }

}
